import { isObject } from './utils';
import { hasMultilineAddress } from './has-multiline-address';
const removeFalsyValues = (values = {}) => {
    return Object.keys(values).reduce((withoutFalsy, target) => {
        const value = values[target];
        if (value === '' || typeof value === 'undefined' || value === null) {
            return withoutFalsy;
        }
        if (Array.isArray(value) && !value.length) {
            return withoutFalsy;
        }
        if (isObject(value)) {
            withoutFalsy[target] = removeFalsyValues(value);
        }
        else {
            withoutFalsy[target] = value;
        }
        return withoutFalsy;
    }, {});
};
const getFormValidator = async (form, addressTemplates, validationMode) => {
    const [{ FormValidator }, { MultilineAddressToolkit }] = await Promise.all([
        import(/* webpackChunkName: "form-validator" */ '@wix/form-validator'),
        import(
        /* webpackChunkName: "form-multiline-address" */ '@wix/form-multiline-address'),
    ]);
    if (addressTemplates?.length) {
        const addressForms = addressTemplates.map((template) => template.template);
        const addressToolkit = new MultilineAddressToolkit(addressForms);
        return new FormValidator([form], validationMode, false, addressToolkit.getFormForValidation, addressToolkit.normalizeEmptyValues, true);
    }
    return new FormValidator([form], validationMode, undefined, undefined, undefined, true);
};
export const validate = async (form, values, addressTemplates, validationMode) => {
    if (!form.id) {
        return;
    }
    const formValidator = await getFormValidator(form, addressTemplates, validationMode);
    return formValidator.validate(form.id, hasMultilineAddress(form, { excludeEcomAddress: true })
        ? values
        : removeFalsyValues(values));
};
export const validateFields = async (form, values, addressTemplates, validationMode) => {
    if (!form.id) {
        return;
    }
    const formValidator = await getFormValidator(form, addressTemplates, validationMode);
    return formValidator.validateFields(form.id, hasMultilineAddress(form) ? values : removeFalsyValues(values));
};
//# sourceMappingURL=validation.js.map